// performs POST request through whatwg-fetch to Rails app including cookies and CSRF-TOKEN

import fetch from 'isomorphic-fetch'

export default function railsPostFetch(url, data = {}) {
  data.method || (data.method = 'POST')
  data.credentials || (data.credentials = 'include')
  data.mode || (data.mode = 'same-origin')

  data.headers || (data.headers = {})

  data.headers['X-CSRF-Token'] || (data.headers['X-CSRF-Token'] = getCSRFToken())
  data.headers['Accept'] || (data.headers['Accept'] = 'application/json')
  data.headers['Content-Type'] || (data.headers['Content-Type'] = 'application/json')
  return fetch(url, data)
}

export function getCSRFParam() {
  try {
    return document.querySelector('meta[name="csrf-param"]').getAttribute('content')
  } catch {
    return null
  }
}
export function getCSRFToken() {
  try {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  } catch {
    return null
  }
}

// Parses a JSON response and intercepts the application-level CSRF-failure
// envelope (`{ csrf_failure: true }` with HTTP 401, see OQ-LOG-34 resolution).
// When the token went stale (session rotated in another tab, deploy bounced,
// idle session reset), the form's <meta csrf-token> is also stale and every
// retry will fail the same way — so we reload the page to pick up a fresh
// token from the server-rendered <meta>. Callers MUST handle the `null`
// return as "reload triggered, abort this submit".
// Set by redirectTo: a late 401 landing while a post-submit navigation is in
// flight must not reload the page out from under it (OQ-CC-10 hijack).
let navigationInFlight = false

export function markNavigationInFlight() {
  navigationInFlight = true
}

export async function parseRailsJsonResponse(response) {
  const data = await response.json()
  if (response.status === 401 && data && data.csrf_failure) {
    if (!navigationInFlight) window.location.reload()
    return null
  }
  return data
}

export function postForm(url, data = {}) {
  const form = document.createElement('form')
  form.setAttribute('method', 'post')
  form.setAttribute('action', url)
  form.setAttribute('target', 'view')

  const hiddenField = document.createElement('input')
  hiddenField.setAttribute('type', 'hidden')
  hiddenField.setAttribute('name', 'data')
  hiddenField.setAttribute('value', JSON.stringify(data))

  form.appendChild(hiddenField)

  const i = document.createElement('input')
  i.setAttribute('type', 'hidden')
  i.setAttribute('name', 'authenticity_token')
  i.setAttribute('value', getCSRFToken())

  form.appendChild(i)

  document.body.appendChild(form)

  window.open('', 'view')

  form.submit()
}
